/** IEC 60617-style fuse symbol. */
export function FuseSymbol({
  width = 14,
  height = 8,
  opacity = 0.7,
}: {
  width?: number;
  height?: number;
  opacity?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 8"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      aria-hidden
      style={{
        flex: "none",
        opacity,
        width: `${width}px`,
        height: `${height}px`,
        position: "relative",
      }}
    >
      <rect x={0.5} y={0.5} width={13} height={7} rx={2} ry={2} />
      <line x1={0.5} y1={4} x2={13.5} y2={4} />
    </svg>
  );
}
